(() => {
  if (window.kissImageFitStarted) return;
  window.kissImageFitStarted = true;
  const selector = 'product-card .card-gallery .product-media[data-media-id]';
  const script = document.querySelector('script[data-kiss-image-fit]');
  if (!script?.dataset.mapUrl) return;
  let map = {}, active = false;
  const seen = new WeakSet();
  function fit(stage) {
    const meta = map[stage.dataset.mediaId];
    const img = stage.querySelector('img.product-media__image');
    if (!meta || !img) return;
    const [iw, ih, x0, y0, x1, y1] = meta;
    const w = stage.clientWidth, h = stage.clientHeight;
    if (w < 40 || h < 40) return;
    const pad = w < 220 ? 10 : 14;
    const bw = x1 - x0, bh = y1 - y0;
    const originalScale = Math.min((w - 2 * pad) / iw, (h - 2 * pad) / ih);
    const scale = Math.min((w - 2 * pad) / (iw * bw), (h - 2 * pad) / (ih * bh), originalScale * 1.8);
    const dw = iw * scale, dh = ih * scale;
    const left = (w - dw * bw) / 2 - dw * x0;
    const top = (h - dh * bh) / 2 - dh * y0;
    stage.dataset.kissFit = 'ready';
    stage.style.setProperty('--kiss-photo-width', `${dw.toFixed(2)}px`);
    stage.style.setProperty('--kiss-photo-height', `${dh.toFixed(2)}px`);
    stage.style.setProperty('--kiss-photo-left', `${left.toFixed(2)}px`);
    stage.style.setProperty('--kiss-photo-top', `${top.toFixed(2)}px`);
  }
  const resize = new ResizeObserver(entries => entries.forEach(entry => fit(entry.target)));
  function scan() {
    if (!active) return;
    document.querySelectorAll(selector).forEach(stage => {
      if (!map[stage.dataset.mediaId]) return;
      fit(stage);
      if (!seen.has(stage)) { seen.add(stage); resize.observe(stage); }
    });
  }
  let pending = false;
  const changes = new MutationObserver(records => {
    if (pending || !records.some(r => r.addedNodes.length)) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; scan(); });
  });
  fetch(script.dataset.mapUrl, {credentials:'same-origin'})
    .then(r => { if (!r.ok) throw new Error('Image fit map unavailable'); return r.json(); })
    .then(data => {
      map = data; active = true; scan();
      const root = document.getElementById('MainContent');
      if (root) changes.observe(root, {childList:true, subtree:true});
      document.addEventListener('shopify:section:load', scan);
    })
    .catch(() => { /* Original contain layout remains fully usable. */ });
})();
